import React, { useState, useEffect } from 'react';
import { getUserInfo } from '../../common/cookie';
import LogApi from '../../api/LogApi';
import PageNavigation from '../pageNavigation/PageNavigation';
import { getDate, getDateTime } from '../../common/util';

const pageOptions = [
    { key: 30, value: 30, text: '30개씩 보기', active: true, selected: true },
    { key: 50, value: 50, text: '50개씩 보기' },
    { key: 100, value: 100, text: '100개씩 보기' },
    { key: 300, value: 300, text: '300개씩 보기' }
];

const getApproveTypeText = (type) => {
    switch (type) {
        case '001': return '등록';
        case '002': return '수정';
        case '003': return '연장';
        case '004': return '삭제';
        default: return '알 수 없음';
    }
};

const LogList = ({ total, dateRange }) => {
    const [canManage, setCanManage] = useState(false);
    const [list, setList] = useState([]);
    const [curPage, setCurPage] = useState(1);
    const [pageCount, setPageCount] = useState(30);
    const [keyword, setKeyword] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    // FUNCTION
    const init = (page = curPage, count = pageCount, searchKeyword = keyword, searchDateRange = dateRange) => {
        setIsLoading(true);
        
        const params = {
            page,
            count,
            keyword: searchKeyword,
            dateRange: searchDateRange
        };

        console.log(searchDateRange, '???????');

        LogApi.getLogList(params).then(rslt => {
            if (rslt.code === 'success') {
                const { data: { list } } = rslt;
                setList(list);
                setCurPage(page);
            } else {
                console.error('로그 목록 조회 실패:', rslt.message);
            }
            setIsLoading(false);
        }).catch(error => {
            console.error('로그 목록 조회 오류:', error);
            alert('로그 목록 조회 중 오류가 발생했습니다.');
            setIsLoading(false);
        });
    };

    // EVENT
    const handlePageChange = page => {
        if (page === curPage) return;
        setCurPage(page);
        init(page);
    };

    const handleKeyDown = event => {
        if (event.key === 'Enter') {
            init(1, pageCount, keyword, dateRange);
        }
    };

    const handleCountSelect = (e) => {
        const newCount = parseInt(e.target.value);
        setPageCount(newCount);
        init(1, newCount);
    };

    const handleKeywordChange = (e) => {
        setKeyword(e.target.value);
    };

    const handleSearch = () => {
        init(1, pageCount, keyword, dateRange);
    };

    // EFFECT
    useEffect(() => {
        const userInfo = getUserInfo();
        const userType = userInfo?.userType || userInfo?.USER_TYPE;
        const isAdmin = !!userInfo?.isAdmin || userType === '001';
        const isSubAdmin = !!userInfo?.isSubAdmin || userType === '011';
        setCanManage(isAdmin || isSubAdmin);
    }, []);

    useEffect(() => {
        init();
    }, []);

    // dateRange가 변경될 때마다 목록 새로고침
    useEffect(() => {
        if (dateRange !== undefined) {
            init(1, pageCount, keyword, dateRange);
        }
    }, [dateRange]);

    if (!canManage) {
        return (
            <div className="vh-content-wrap">
                <div className="content-header">
                    <h1>로그관리</h1>
                    <h2>관리자 권한이 필요합니다.</h2>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="filter-area">
                <div className="filter-search">
                    <div className="field-search">
                        <input 
                            placeholder="유저 아이디 검색"
                            value={keyword}
                            onChange={handleKeywordChange}
                            onKeyDown={handleKeyDown}
                        />
                        <button type="button" onClick={handleSearch}>
                            <i className="icon icon-search"></i>
                        </button>
                    </div>
                </div>
            </div>

            <div className="table-area">
                <table className="sortable">
                    <colgroup>
                        <col width="5%" />      
                        <col width="10%" />
                        <col width="10%" />
                        <col width="10%" />
                        <col width="10%" />
                        <col width="10%" />
                        <col width="10%" />
                        <col width="10%" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th className="sorttable_nosort">번호</th>
                            <th className="sorttable_nosort">구분</th>
                            <th className="sorttable_nosort">사용자 ID</th>
                            <th className="sorttable_nosort">수량</th>
                            <th className="sorttable_nosort">기간</th>
                            <th className="sorttable_nosort">일수 합계</th>
                            <th className="sorttable_nosort">생성 일시</th>
                            <th className="sorttable_nosort">작업 시작일</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.map(item => (
                            <tr key={`log_${item.ID}`}>
                                <td>{item.ID}</td>
                                <td>{getApproveTypeText(item.APPROVE_TYPE)}</td>
                                <td>{item.USER_ID}</td>
                                <td>{item.APPROVE_SLOT_QUANTITY}</td>
                                <td>{item.APPROVE_DAYS}</td>
                                <td>{item.APPROVE_SLOT_QUANTITY * item.APPROVE_DAYS * (item.APPROVE_TYPE === '001' ? 1 : -1)}</td>
                                <td>{getDateTime(item.REG_DTM)}</td>
                                <td>{getDate(item.START_DATE)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="table-nav">
                <PageNavigation totalCount={total} showCount={pageCount} onChange={handlePageChange} />
                <div className="table-nav-row">
                    <div>
                        <select onChange={handleCountSelect} value={pageCount}>
                            {pageOptions.map(option => (
                                <option key={option.key} value={option.value}>{option.text}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LogList;
